import styled from "styled-components";
import { ArrowExpand, PlusCircled } from "assets/images";

export const Wrapper = styled.div`
    height: 96vh;
    width: 100%;
    padding: 20px 65px;
    display: flex;
    flex-direction: column;
overflow:hidden;
    background-color: rgba(251, 255, 251, 1);

    textarea:focus,
    input:focus {
        outline: none;
    }

    * {
    }
`;
//
export const HeaderTitle = styled.h3`
    display: flex;
    font-size: 24px;
`;
export const HedgeInstIdBlock = styled.span`
    font-size: 16px;
    display: flex;
    align-items: center;
`;
export const FlexBlock = styled.span`
    display: flex;
    align-items: center;
    justify-content: flex-between;
    gap: 10px;
`;
export const GroupNameInput = styled.input`
    outline: none;
    border: none;
    max-width: 200px;

    :focus {
        border-bottom: 2px solid #7cbe7b;
    }
`;
export const TickerNameInput = styled(GroupNameInput)`
    max-width: 240px;
`;

export const Workspace = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    height: 100%;
    width: 100%;
    overflow: auto;
    flex-grow: 1;

    & > * {
        flex-shrink: 0;
    }
`;
export const ErrorBlock = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    margin: 20px 0;
    background-color: #fdf7f7ff;
    border-left: 1px solid #ff4d4f;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(255, 77, 79, 0.15);
    min-height: 60px;
`;
export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-self: flex-end;

    button {
        margin-right: 10px;
    }
    @media (max-width: 768px) {
        position: sticky;
        bottom: 0;
        z-index: 10;
        border-top: 1px solid #eee;
    }
    @media (hover: none) and (pointer: coarse) {
        position: fixed;
        right: 0;
        bottom: 0;
        z-index: 1000;
        padding: 10px;
        background: #fbfffb;
        border-top: 1px solid #eee;
        justify-content: center;
    }
`;

export const CustomArrowExpand = styled(ArrowExpand)`
    cursor: pointer;
    margin-right: 10px;
`;
export const CustomPlusCircled = styled(PlusCircled)`
    cursor: pointer;
    margin-right: 10px;
`;

export const SettingsBlockWrapper = styled.div`
    //min-width: 440px;
`;
export const CPSettingsBlockWrapper = styled.div`
    min-width: 330px;
`;
export const MDPSettingsBlockWrapper = styled.div`
    min-width: 380px;
    // max-width: 400px;
`;

export const SettingsBlockHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin:0;
    padding: 8px 0;
    max-width: 330px;
`;

export const MDPBlockHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items:center
    justify-content: space-between;

    margin-bottom: 10px;
    max-width: 330px;
`;
export const MDPButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;
export const SettingsBlockTitle = styled.h4`
    padding-left: 15px;
    font-size: 18px;
`;
export const SettingsBlockButtons = styled.div``;
export const BlockWrapper = styled.div`
    height: 90%;
`;
export const SettingsTitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
`;
